"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var CenterBlock = /** @class */ (function (_super) {
    __extends(CenterBlock, _super);
    function CenterBlock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getTitleOffset = function () {
            var headOptions = _this.props.headOptions;
            var titleOffset = 0;
            if (headOptions) {
                if (headOptions.title && headOptions.title.text) {
                    titleOffset += 25;
                }
                if (headOptions.subtitle && headOptions.subtitle.text) {
                    titleOffset += 25;
                }
            }
            return titleOffset;
        };
        _this.getOffset = function () {
            var chart = _this.props.chart;
            var titleOffset = _this.getTitleOffset();
            var coordinates = { x: 0, y: 0 };
            if (chart) {
                var plotLeft = chart.plotLeft, plotTop = chart.plotTop, plotHeight = chart.plotHeight, plotWidth = chart.plotWidth;
                coordinates.x = plotLeft + plotWidth / 2;
                coordinates.y = titleOffset + plotTop + plotHeight / 2;
            }
            return coordinates;
        };
        return _this;
    }
    CenterBlock.prototype.render = function () {
        var content = this.props.content;
        var _a = this.getOffset(), x = _a.x, y = _a.y;
        return (React.createElement("div", { style: { top: y, left: x }, className: "center-block" }, content));
    };
    return CenterBlock;
}(React.Component));
exports.default = CenterBlock;
//# sourceMappingURL=CenterBlock.js.map